import React from 'react'
import { FormattedMessage } from 'react-intl'
import { HubText } from './HubWidgets'

export const HubFormattedMessage = (props: any) => (
  <HubText>
    <FormattedMessage {...props} />
    {props.suffix ? <span>{props.suffix}</span> : null}
  </HubText>
)
